import React from 'react';
import {withSystem, Plugins, Atom} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {UsysUtilityPageConstraint} from './utils';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {TRecord, TText, TListOfElement} from '@packages/systems/wfdl-ast';
import {getChildren} from '@packages/utilities/data-utils';

const UserFormBlockLabel = Atom.createRender(
  ({attributes, classes, generateAttributes, innerHTML, data, renderChild}) => {
    return (
      // TODO: fix jsx-a11y lint error
      // eslint-disable-next-line jsx-a11y/label-has-for
      <label {...generateAttributes(attributes, classes)}>
        {/* @ts-expect-error - TS2322 - innerHTML union includes non-ReactNode array types (TODO platform: fix innerHTML type issues) */}
        {innerHTML || getChildren(data).map((child) => renderChild(child))}
      </label>
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'Field Label',
  constraints: {
    page: [UsysUtilityPageConstraint],
  },
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Text')),
  },
  showEmpty: true,
  render: UserFormBlockLabel,
  fields: {
    attr: TRecord({
      for: TText,
    }),
    users: TRecord({
      field: withSystem({private: true}, TText),
    }),
    children: TListOfElement,
  },
});

export default config;
